export const formatDate = (timestamp) => {
    if (typeof timestamp === 'number') {
        let jsDateFormat = new Date(timestamp)
        let fullStringTime = {
            day: Number(jsDateFormat.getDate() < 10) ? '0' + jsDateFormat.getDate() : jsDateFormat.getDate(),
            month: Number((jsDateFormat.getMonth() + 1)) < 10 ? '0' + (jsDateFormat.getMonth() + 1) : (jsDateFormat.getMonth() + 1),
            year: jsDateFormat.getFullYear(),
            hours: Number(jsDateFormat.getHours()) < 10 ? '0' + jsDateFormat.getHours() : jsDateFormat.getHours(),
            minutes: Number(jsDateFormat.getMinutes()) < 10 ? '0' + jsDateFormat.getMinutes() : jsDateFormat.getMinutes()
        }
        return fullStringTime.day + '/' + fullStringTime.month + '/' + fullStringTime.year + ' ';
    }
    return null;
}

